import { MD, XS } from "constants/sizes";
import GridParagraphWithImage from "segments/desktop/core-components/grid-paragraph-with-image/grid-paragraph-with-image";
import classnames from "classnames";
import Carousel from "segments/desktop/core-components/carousel/carousel";
import { generateOnKeyDownHandler } from "client/services/accessibility/accessibility-service";
import { useMemo } from "react";
import { CAROUSEL_ARROW_CLICKED } from "constants/bigbrain-event-types";
import { trackEvent } from "services/bigbrain-service";
import Colors from "styles/colors";
import PrevCarouselArrow from "./prev-carousel-arrow";
import NextCarouselArrow from "./next-carousel-arrow";
import { componentStyles } from "./sliding-card-grid-base-component.scss";

const SlidingCardGridBaseComponent = ({
  cards,
  cardsToShow,
  cardColor,
  cardInnerPadding,
  borderColor,
  arrowsColor,
  isFullScreen,
  fullParagraphAdvancedConfig
}) => {
  const itemRenderer = (card) => (
    <GridParagraphWithImage
      {...card}
      fullParagraph={{ ...fullParagraphAdvancedConfig, ...card.fullParagraph }}
      borderColor={borderColor}
      cardColor={cardColor}
      padding={cardInnerPadding}
      width="100%"
      height="100%"
      titleSize={XS}
      textSize={MD}
    />
  );

  const areCardsToShowUnevenNumber = useMemo(
    () => Number(cardsToShow) < cards.length && !Number.isInteger(Number(cardsToShow)),
    [cards.length, cardsToShow]
  );

  const PrevArrow = ({ className, onClick }) => {
    const onPrevArrowClick = () => {
      if (onClick) {
        trackEvent(CAROUSEL_ARROW_CLICKED, { info3: "prev" });
        onClick();
      }
    };

    return (
      <button
        type="button"
        className={classnames(className, "carousel-arrow-wrapper", "prev")}
        onClick={onPrevArrowClick}
        tabIndex={0}
        onKeyDown={generateOnKeyDownHandler(onClick)}
      >
        <PrevCarouselArrow isDisabled={!onClick} color={Colors[arrowsColor]} />
      </button>
    );
  };

  const NextArrow = ({ className, onClick }) => {
    const onNextArrowClick = () => {
      if (onClick) {
        trackEvent(CAROUSEL_ARROW_CLICKED, { info3: "next" });
        onClick();
      }
    };

    return (
      <button
        type="button"
        className={classnames(className, "carousel-arrow-wrapper", "next")}
        onClick={onNextArrowClick}
        tabIndex={0}
        onKeyDown={generateOnKeyDownHandler(onClick)}
      >
        <NextCarouselArrow isDisabled={!onClick} color={Colors[arrowsColor]} />
      </button>
    );
  };

  const carouselProps = {
    items: cards,
    itemRenderer,
    defaultIndex: 0,
    infinite: false,
    centerMode: false,
    slidesToShow: Number(cardsToShow) || undefined,
    centerPadding: "15%",
    arrows: true,
    swipeToSlide: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />
  };

  return (
    <div
      className={classnames("sliding-card-grid-component", {
        "full-carousel-width": areCardsToShowUnevenNumber,
        "full-screen": isFullScreen
      })}
    >
      <Carousel {...carouselProps} />
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default SlidingCardGridBaseComponent;
